import { generateApiRoute } from '@klp/core/api/helpers';

const byggApiName = 'bygg';

export const byggApiRoutes = {
    list: () => generateApiRoute([byggApiName]),
    listForKunde: (kundenummer: string) =>
        generateApiRoute([byggApiName, 'kundenummer', kundenummer]),
    single: (byggNummer?: string) =>
        generateApiRoute([byggApiName, byggNummer]),
    tegning: (id: string) =>
        generateApiRoute([byggApiName, 'byggtegning', 'download', id]),
    moteromKalendar: (byggNummer?: string) =>
        generateApiRoute([byggApiName, 'moterom', byggNummer, 'calendar']),
    moteromList: (byggNummer: string, kundenummer: string) =>
        generateApiRoute([byggApiName, 'moterom', byggNummer]) +
        '?' +
        new URLSearchParams({ kundenummer }).toString(),
};
